import { openConfirm } from '../../_Components/Confirm';

export function confirm(obj, onConfirm, onClose) {
    openConfirm(obj, onConfirm, onClose);
}